(function() {
  'use strict';
  
  function getQuantityLimitMessage(template, values) {
    const templateElement = document.querySelector(`[data-template="${template}"]`);
    if (!templateElement) return 'Error: Template not found';
    
    let message = templateElement.textContent;
    
    if (values.maxQuantity !== undefined) {
      message = message.replace(/MAX_QTY_PLACEHOLDER/g, values.maxQuantity);
    }
    if (values.currentQuantity !== undefined) {
      message = message.replace(/CURRENT_QTY_PLACEHOLDER/g, values.currentQuantity);
    }
    if (values.allowedQuantity !== undefined) {
      message = message.replace(/ALLOWED_QTY_PLACEHOLDER/g, values.allowedQuantity);
    }
    if (values.requestedQuantity !== undefined) {
      message = message.replace(/REQUESTED_QTY_PLACEHOLDER/g, values.requestedQuantity);
    }
    
    return message;
  }
  
  function showQuantityModal(message, productInfo = null) {
    document.getElementById('quantity-modal-message').textContent = message;
    
    const productElement = document.getElementById('quantity-modal-product');
    if (productInfo && productInfo.title) {
      document.getElementById('quantity-modal-product-title').textContent = productInfo.title;
      document.getElementById('quantity-modal-product-variant').textContent = productInfo.variant || '';
      document.getElementById('quantity-modal-product-image').src = productInfo.image || '';
      document.getElementById('quantity-modal-product-image').alt = productInfo.title;
      productElement.style.display = 'flex';
    } else {
      productElement.style.display = 'none';
    }
    
    document.getElementById('quantity-limit-modal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  
  function closeQuantityModal() {
    document.getElementById('quantity-limit-modal').style.display = 'none';
    document.body.style.overflow = '';
  }
  
  window.closeQuantityModal = closeQuantityModal;
  
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('quantity-modal-overlay')) {
      closeQuantityModal();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.getElementById('quantity-limit-modal').style.display === 'block') {
      closeQuantityModal();
    }
  });
  
  const originalFetch = window.fetch;
  
  window.fetch = async function(...args) {
    let [url, options] = args;
    
    if(url instanceof URL){
      url = url.href;
    }
    
    if (url && (url.includes('add.js') || url.includes('/cart/add'))) {
      if (options && options.body && typeof options.body === 'string') {
        try {
          let requestData = JSON.parse(options.body);
          
          if (requestData.properties && requestData.properties._rpq && requestData.quantity && requestData.id) {
            const maxQuantity = parseInt(requestData.properties._rpq);
            const requestedQuantity = parseInt(requestData.quantity);
            const variantId = requestData.id;
            
            try {
              const cartResponse = await originalFetch('/cart.js');
              const cart = await cartResponse.json();
              
              let currentQuantityInCart = 0;
              if (cart.items) {
                const existingItem = cart.items.find(item => item.variant_id == variantId);
                if (existingItem) {
                  currentQuantityInCart = existingItem.quantity;
                }
              }
              
              const totalAfterAdd = currentQuantityInCart + requestedQuantity;
              
              if (totalAfterAdd > maxQuantity) {
                const allowedToAdd = Math.max(0, maxQuantity - currentQuantityInCart);
                
                let productInfo = null;
                const productElement = document.querySelector(`[data-variant-id="${variantId}"]`) || 
                                     document.querySelector(`input[name="id"][value="${variantId}"]`);
                
                if (productElement) {
                  const productContainer = productElement.closest('[data-product-title]') || 
                                         productElement.closest('.product') || 
                                         productElement.closest('.card');
                  
                  if (productContainer) {
                    const title = productContainer.getAttribute('data-product-title') || 
                                 productContainer.querySelector('h1, h2, h3, .product-title')?.textContent || 
                                 document.title;
                    const image = productContainer.querySelector('img')?.src || 
                                 document.querySelector('meta[property="og:image"]')?.content;
                    
                    productInfo = {
                      title: title.trim(),
                      image: image,
                      variant: null
                    };
                  }
                }
                
                if (allowedToAdd <= 0) {
                  const message = getQuantityLimitMessage('max-reached', { maxQuantity });
                  showQuantityModal(message, productInfo);
                  requestData.quantity = '0';
                  options.body = JSON.stringify(requestData);
                } else {
                  const message = getQuantityLimitMessage('adjusted-add', { 
                    maxQuantity, 
                    currentQuantity: currentQuantityInCart, 
                    allowedQuantity: allowedToAdd, 
                    requestedQuantity 
                  });
                  showQuantityModal(message, productInfo);
                  requestData.quantity = allowedToAdd.toString();
                  options.body = JSON.stringify(requestData);
                }
              }
            } catch (cartError) {
              if (requestedQuantity > maxQuantity) {
                let productInfo = {
                  title: document.title || 'Product',
                  image: document.querySelector('meta[property="og:image"]')?.content,
                  variant: null
                };
                
                const message = getQuantityLimitMessage('adjusted-change', { maxQuantity, requestedQuantity });
                showQuantityModal(message, productInfo);
                requestData.quantity = maxQuantity.toString();
                options.body = JSON.stringify(requestData);
              }
            }
          }
        } catch (e) {
        }
      }
    }
    
    if (url && (url.includes('change.js') || url.includes('/cart/change'))) {
      if (options && options.body && typeof options.body === 'string') {
        try {
          let requestData;
          
          if (options.body.startsWith('{') || (options.headers && 
              (options.headers['Content-Type'] === 'application/json' || 
               options.headers['content-type'] === 'application/json'))) {
            requestData = JSON.parse(options.body);
          } else {
            requestData = {};
            const params = new URLSearchParams(options.body);
            for (const [key, value] of params) {
              requestData[key] = value;
            }
          }
          
          if (requestData.line && requestData.quantity) {
            const lineIndex = parseInt(requestData.line);
            const newQuantity = parseInt(requestData.quantity);
            
            try {
              const cartResponse = await originalFetch('/cart.js');
              const cart = await cartResponse.json();
              
              if (cart.items && cart.items[lineIndex - 1]) {
                const item = cart.items[lineIndex - 1];
                
                if (item.properties && item.properties._rpq) {
                  const maxQuantity = parseInt(item.properties._rpq);
                  
                  if (newQuantity > maxQuantity) {
                    const productInfo = {
                      title: item.product_title || item.title || 'Product',
                      image: item.image || item.featured_image?.url,
                      variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : null
                    };
                    
                    const message = getQuantityLimitMessage('adjusted-change', { maxQuantity, requestedQuantity: newQuantity });
                    showQuantityModal(message, productInfo);
                    
                    if (options.body.startsWith('{')) {
                      requestData.quantity = maxQuantity.toString();
                      options.body = JSON.stringify(requestData);
                    } else {
                      const params = new URLSearchParams(options.body);
                      params.set('quantity', maxQuantity.toString());
                      options.body = params.toString();
                    }
                  }
                }
              }
            } catch (cartError) {
            }
          }
        } catch (e) {
        }
      }
    }
    
    return originalFetch.apply(this, args);
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this._interceptedURL = url;
    this._interceptedMethod = method;
    
    
    return originalXHROpen.apply(this, [method, url, ...args]);
  };
  
  XMLHttpRequest.prototype.send = function(data) {
    const xhr = this;
    
    if (this._interceptedURL && this._interceptedMethod) {
      
      const isAddToCartXHR = this._interceptedURL && (
        this._interceptedURL.includes('add.js') || 
        this._interceptedURL.includes('/cart/add') ||
        this._interceptedURL.includes('cart/add.js') ||
        (this._interceptedURL.includes('/cart') && this._interceptedMethod === 'POST')
      );
      
      if (isAddToCartXHR) {
        
        if (data instanceof FormData) {
          const formDataEntries = {};
          for (const [key, value] of data.entries()) {
            formDataEntries[key] = value;
          }
          
          const variantId = formDataEntries.id;
          const requestedQuantity = parseInt(formDataEntries.quantity);
          const maxQuantity = formDataEntries['properties[_rpq]'] ? parseInt(formDataEntries['properties[_rpq]']) : null;
          
          if (variantId && requestedQuantity && maxQuantity) {
            
            const cartXHR = new XMLHttpRequest();
            cartXHR.open('GET', '/cart.js', false); // false = síncrono
            cartXHR.send();
            
            if (cartXHR.status === 200) {
              try {
                const cart = JSON.parse(cartXHR.responseText);
                let currentQuantityInCart = 0;
                
                if (cart.items) {
                  const existingItem = cart.items.find(item => item.variant_id == variantId);
                  if (existingItem) {
                    currentQuantityInCart = existingItem.quantity;
                  }
                }
                
                const totalAfterAdd = currentQuantityInCart + requestedQuantity;
                
                if (totalAfterAdd > maxQuantity) {
                  const allowedToAdd = Math.max(0, maxQuantity - currentQuantityInCart);
                  
                  let productInfo = null;
                  const productElement = document.querySelector(`[data-variant-id="${variantId}"]`) || 
                                       document.querySelector(`input[name="id"][value="${variantId}"]`);
                  
                  if (productElement) {
                    const productContainer = productElement.closest('[data-product-title]') || 
                                           productElement.closest('.product') || 
                                           productElement.closest('.card');
                    
                    if (productContainer) {
                      const title = productContainer.getAttribute('data-product-title') || 
                                   productContainer.querySelector('h1, h2, h3, .product-title')?.textContent || 
                                   document.title;
                      const image = productContainer.querySelector('img')?.src || 
                                   document.querySelector('meta[property="og:image"]')?.content;
                      
                      productInfo = {
                        title: title.trim(),
                        image: image,
                        variant: null
                      };
                    }
                  }
                  
                  if (allowedToAdd <= 0) {
                    const message = getQuantityLimitMessage('max-reached', { maxQuantity });
                    showQuantityModal(message, productInfo);
                    data.set('quantity', '0');
                  } else {
                    const message = getQuantityLimitMessage('adjusted-add', { 
                      maxQuantity, 
                      currentQuantity: currentQuantityInCart, 
                      allowedQuantity: allowedToAdd, 
                      requestedQuantity 
                    });
                    showQuantityModal(message, productInfo);
                    data.set('quantity', allowedToAdd.toString());
                  }
                }
              } catch (parseError) {
                console.error('Error parsing cart response:', parseError);
              }
            } else {
              console.error('Error fetching cart:', cartXHR.status);
              if (requestedQuantity > maxQuantity) {
                let productInfo = {
                  title: document.title || 'Product',
                  image: document.querySelector('meta[property="og:image"]')?.content,
                  variant: null
                };
                
                const message = getQuantityLimitMessage('adjusted-change', { maxQuantity, requestedQuantity });
                showQuantityModal(message, productInfo);
                data.set('quantity', maxQuantity.toString());
              }
            }
          }
        }
      }
    }
    return originalXHRSend.apply(this, [data]);
  };
})();